import { Box, Stack, Typography } from '@mui/material';
import { Omit } from 'lodash';
import { ComponentProps } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { Tooltip } from '@/components/poppers/Tooltip/Tooltip';
import { IntegrationProvider } from '@/types/schema';

import { ResyncClientsEntitiesButton } from './ResyncClientsEntitiesButton/ResyncClientsEntitiesButton';

export interface IntegrationRowProps {
  description?: string;
  integrationEnabled: boolean;
  isExpired?: boolean;
  externalUserName?: string | null;
  logo: React.ReactNode;
  buttonProps: Omit<ComponentProps<typeof Button>, 'size' | 'variant'>;
  integrationProvider: IntegrationProvider;
}

export function IntegrationRow({
  description,
  integrationEnabled,
  isExpired,
  externalUserName,
  logo,
  buttonProps,
  integrationProvider,
}: IntegrationRowProps) {
  return (
    <Box>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          {logo}
          {integrationEnabled && !isExpired && (
            <Tooltip
              title={`Linked using ${externalUserName}`}
              show={!!externalUserName}
            >
              <Badge variant={BadgeVariants.Warning} display="Enabled" />
            </Tooltip>
          )}
          {isExpired && (
            <Badge variant={BadgeVariants.Destructive} display="Expired" />
          )}
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Button
            size="xs"
            rel="noreferrer"
            external
            target="_self"
            variant={integrationEnabled ? 'secondary' : 'primary'}
            {...buttonProps}
          />
          {integrationEnabled && (
            <ResyncClientsEntitiesButton
              integrationProvider={integrationProvider}
            />
          )}
        </Stack>
      </Stack>
      {description && (
        <Typography variant="body-xs" component="div">
          {description}
        </Typography>
      )}
    </Box>
  );
}
